<div class="a-caution" [ngStyle]="style">
  <div class="a-caution-title">
    <i class="{{titleIcon}}" aria-hidden="true"></i><span>{{title}}</span>
  </div>
  <div class="a-caution-body">
    <div class="a-caution-message">{{message}}</div>
    <div class="a-caution-addtional" *ngIf="includeDefaultComment||addtionalBodyTemplate">
      <ng-container *ngTemplateOutlet="includeDefaultComment?defaultAddtional:addtionalBodyTemplate;context:{$implicit:cautionContext}"></ng-container>
    </div>
  </div>
  <div class="{{'a-caution-footer '+ footerClass}}">
    <ng-container *ngTemplateOutlet="footerTemplate||defaultFooter;context:{$implicit:cautionContext}"></ng-container>
  </div>
</div>

<ng-template #defaultFooter let-context>
  <button class="{{'a-corner-all a-height-30 '+cancelBtnClass}}"
  [ngClass]="{'show-icon icon-size16':confirmIcon!=null}"
    icon="{{cancelIcon}}" type="button" pButton
    label="{{cancelText}}" (click)="onCancel()"
    *ngIf="!isCancelHidden"></button>
  <button class="{{'a-corner-all a-height-30 '+confirmBtnClass }}"
    [ngClass]="{'show-icon icon-size16':confirmIcon!=null}"
    [disabled]="context?.confirmButtonDisable"
    icon="{{confirmIcon}}"
    type="button" pButton label="{{confirmText}}"
            (click)="onConfirm()"></button>
</ng-template>

<ng-template #defaultAddtional let-context>
  <label for="comment">Comments</label><br/>
  <textarea id="comment" cols="60" rows="10"
    pInputTextarea autocomplete="off" value="{{context.result}}"
    (input)="onCommentChange($event,context)"
    ></textarea>
</ng-template>
